import React from 'react';
import {
  CalendarPlus, Gift, UserCheck, X, Eye,
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { Textarea } from '../../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const DeleteAllStoriesDialog = ({ ctx }) => {
  const { showDeleteAllDialog, setShowDeleteAllDialog, deletingAll, handleDeleteAllStories } = ctx;
  return (
          <Dialog open={showDeleteAllDialog} onOpenChange={setShowDeleteAllDialog}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle className="text-destructive">Alle verhalen verwijderen?</DialogTitle>
                <DialogDescription>
                  Dit verwijdert ALLE verhalen van het platform, inclusief reviews, favorieten en leesvoortgang. Dit kan niet ongedaan worden gemaakt.
                </DialogDescription>
              </DialogHeader>
              <DialogFooter className="gap-2 sm:gap-0">
                <Button
                  variant="outline"
                  onClick={() => setShowDeleteAllDialog(false)}
                  disabled={deletingAll}
                >
                  Annuleren
                </Button>
                <Button
                  data-testid="confirm-delete-all-stories"
                  variant="destructive"
                  onClick={handleDeleteAllStories}
                  disabled={deletingAll}
                >
                  {deletingAll ? 'Bezig met verwijderen...' : 'Ja, alles verwijderen'}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
  );
};
